import { Navigate, useParams } from "react-router-dom";
import { parseAssetId, StakeMode } from "../config/assets";

interface StakeRedirectProps {
  mode: StakeMode;
}

export const StakeRedirect = ({ mode }: StakeRedirectProps) => {
  const { asset } = useParams<{ asset: string }>();
  const assetId = parseAssetId(asset) ?? "sol";
  return <Navigate to={`/stake/${assetId}?mode=${mode}`} replace />;
};
